import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
  TextField,
} from "@mui/material";
import { Switch } from "../../../UI/Switch";
import React, { ChangeEvent, SyntheticEvent, useEffect, useState } from "react";
import { StyledH2Before } from "./styles";
import { FaCaretDown, FaSave, FaTrashAlt } from "react-icons/fa";
import { AirportSearch } from "../../../Aereo/AirportSearch";
import { Input } from "../../../Input";
import { createOptionsFromEnum } from "../../../../utils/formatters";
import { FlightClass } from "../../../../types/aerial/enums";
import { add, format } from "date-fns";
import YesOrNoSwitch from "../../../UI/YesOrNoSwitch";
import { LabeledAutoComplete } from "../../../UI/LabeledAutoComplete";

type AirportSearchNames =
  | "outwardAirport"
  | "returnAirport"
  | "airportConnections";

type PropTypes = {
  title: string;
  data: any;
  handleDeleteService(id: number): void;
  handleSaveService(form: any, index: number): void;
  index: number;
  expanded: boolean;
  onChange(index: number, state: boolean): void;
  handleDeleteDialog(index: number): void;
};

const AerialServiceItem: React.FC<PropTypes> = ({
  title,
  data,
  handleDeleteService,
  handleSaveService,
  index,
  expanded,
  onChange,
  handleDeleteDialog,
}: PropTypes) => {
  const [state, setState] = useState({
    outwardQuantity: data?.outwardQuantity ? data.outwardQuantity : 0,
    returnQuantity: data?.returnQuantity ? data.returnQuantity : 0,
    outwardDate: data?.outwardDate
      ? format(add(new Date(data.outwardDate), { hours: 4 }), "yyyy-MM-dd")
      : "",
    returnDate: data?.returnDate
      ? format(add(new Date(data.returnDate), { hours: 4 }), "yyyy-MM-dd")
      : "",
    aerialMesh: data?.aerialMesh ? data.aerialMesh : false,
    outwardAirport: data?.outwardAirport ? data.outwardAirport : "",
    returnAirport: data?.returnAirport ? data.returnAirport : "",
    airportConnections: data?.airportConnections ? data.airportConnections : "",
    airportPreference: data?.airportPreference ? data.airportPreference : false,
    flightClass: data?.flightClass ? data.flightClass : ([] as string[]),
    insurance: data?.insurance ? data.insurance : false,
  });

  useEffect(() => {
    setState({
      outwardQuantity: data?.outwardQuantity ? data.outwardQuantity : 0,
      returnQuantity: data?.returnQuantity ? data.returnQuantity : 0,
      outwardDate: data?.outwardDate
        ? format(add(new Date(data.outwardDate), { hours: 4 }), "yyyy-MM-dd")
        : "",
      returnDate: data?.returnDate
        ? format(add(new Date(data.returnDate), { hours: 4 }), "yyyy-MM-dd")
        : "",
      aerialMesh: data?.aerialMesh ? data.aerialMesh : false,
      outwardAirport: data?.outwardAirport ? data.outwardAirport : "",
      returnAirport: data?.returnAirport ? data.returnAirport : "",
      airportConnections: data?.airportConnections
        ? data.airportConnections
        : "",
      airportPreference: data?.airportPreference
        ? data.airportPreference
        : false,
      flightClass: data?.flightClass ? data.flightClass : ([] as string[]),
      insurance: data?.insurance ? data.insurance : false,
    });
    const selectedCategories = flightClassOptions.filter((option: any) =>
      data?.flightClass?.some((item: any) => item === option?.value)
    );
    setSelected(selectedCategories);
  }, [data]);
  const flightClassOptions = createOptionsFromEnum(FlightClass);
  function addAirport(airport: any, fieldName: AirportSearchNames) {
    const e = {
      target: {
        name: fieldName,
        value: airport,
      },
    } as React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;
    handleChange(e);
  }
  function handleChange(
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | any>
  ) {
    if (
      ["insurance", "airportPreference", "aerialMesh"].includes(e.target.name)
    ) {
      setState({ ...state, [e.target.name]: e.target.checked });
    } else setState({ ...state, [e.target.name]: e.target.value });
  }
  const handleSelect = (value: string) => {
    const isPresent = state.flightClass.indexOf(value);
    if (isPresent !== -1) {
      const remaining = state.flightClass.filter((item: any) => item !== value);
      setState({ ...state, flightClass: remaining });
    } else {
      setState({ ...state, flightClass: [...state.flightClass, value] });
    }
  };

  function addAirportConnection() {
    setState({
      ...state,
      airportConnections: [...state.airportConnections, ""],
    });
  }

  function addConnection(airport: any, index: number) {
    const newConnections = state.airportConnections;
    newConnections[index] = airport;
    setState({ ...state, airportConnections: newConnections });
  }
  function removeConnection(connectionIndex: number) {
    setState({
      ...state,
      airportConnections: state.airportConnections.filter(
        (_: any, index: number) => index !== connectionIndex
      ),
    });
  }
  // useEffect(() => {
  //   if (!data._id) {
  //     return
  //   }
  //   setState()
  // }, [data])

  useEffect(() => {
    handleSaveService(state, index);
  }, [state]);

  const [flightCategory, setFlightCategory] = useState("");
  const [selected, setSelected] = useState<any[]>([]);

  function removeDuplicatesByLabel<T extends { label: string }>(
    array: T[]
  ): T[] {
    const seen = new Set<string>();
    return array.filter((item) => {
      if (seen.has(item.label)) {
        return false;
      }
      seen.add(item.label);
      return true;
    });
  }

  const handleChangeCategories = (
    event: SyntheticEvent<Element, Event>,
    newValue: any
  ) => {
    const newValues: any[] = removeDuplicatesByLabel(newValue);
    const formattedValues = newValues.map((i) => i?.value);
    setState({ ...state, flightClass: formattedValues });
    setSelected(newValues);
    setFlightCategory("");
  };

  return (
    <Accordion
      sx={{
        width: "100%",
        boxShadow: "none",
        border: "1px solid #C4C4C4",
        borderRadius: "4px",
        "&::before": {
          display: "none",
        },
      }}
      expanded={expanded}
      TransitionProps={{ unmountOnExit: true }}
      onChange={(_, expanded) => onChange(index, expanded)}
    >
      <AccordionSummary
        aria-controls="panel1a-content"
        expandIcon={<FaCaretDown />}
        id="panel1a-header"
        sx={{
          maxHeight: "40px",
          display: "flex",
          alignItems: "center",
          backgroundColor: "#F8F8F8",
          borderRadius: "4px",
        }}
      >
        <span>{title}</span>{" "}
        <hr style={{ border: "0", height: "1px", background: "#333" }} />
        {state.airportPreference && (
          <Box
            sx={{
              marginRight: 2,
              backgroundColor: "#E72162",
              padding: 0.2,
              color: "white",
              borderRadius: 1,
            }}
          >
            <span>Preferencial</span>
          </Box>
        )}
      </AccordionSummary>

      <AccordionDetails style={{ width: "96%", margin: "auto" }}>
        <Box>
          <Box display={"flex"} gap={2}>
            <AirportSearch
              onSelectAirport={addAirport}
              apiData={state.outwardAirport}
              name="outwardAirport"
              label="Aeroporto de Origem*"
              placeholder="Digite 3 ou mais letras"
            />
            <AirportSearch
              onSelectAirport={addAirport}
              apiData={state.returnAirport}
              name="returnAirport"
              label="Aeroporto de Destino*"
              placeholder="Digite 3 ou mais letras"
            />
          </Box>
          <Box display={"flex"} gap={2}>
            <Input
              value={state.outwardDate}
              onChange={handleChange}
              name="outwardDate"
              label={"Data de ida*"}
              type="date"
            />
            <Input
              value={state.returnDate}
              onChange={handleChange}
              name="returnDate"
              label={"Data de volta*"}
              type="date"
            />
          </Box>
          <Box display={"flex"} gap={2}>
            <Input
              value={state.outwardQuantity}
              onChange={handleChange}
              name="outwardQuantity"
              label={"Quantidade ida*"}
              type="number"
            />
            <Input
              value={state.returnQuantity}
              onChange={handleChange}
              name="returnQuantity"
              label={"Quantidade de volta*"}
              type="number"
            />
          </Box>

          <Box display={"flex"} gap={3} my={2}>
            <Box flexDirection={"column"} display={"flex"} gap={1}>
              <span>Ponte aérea</span>
              <Box>
                <YesOrNoSwitch
                  setValue={(type, newValue) =>
                    setState({ ...state, ["aerialMesh"]: newValue })
                  }
                  type="null"
                  value={state.aerialMesh}
                />
              </Box>
            </Box>
            <Box flexDirection={"column"} display={"flex"} gap={1}>
              <span>Preferência de Aeroportos</span>
              <Box>
                <YesOrNoSwitch
                  setValue={(type, newValue) =>
                    setState({ ...state, ["airportPreference"]: newValue })
                  }
                  type="null"
                  value={state.airportPreference}
                />
              </Box>
            </Box>
            <Box flexDirection={"column"} display={"flex"} gap={1}>
              <span>Seguro</span>
              <Box>
                <YesOrNoSwitch
                  setValue={(type, newValue) =>
                    setState({ ...state, ["insurance"]: newValue })
                  }
                  type="null"
                  value={state.insurance}
                />
              </Box>
            </Box>
            {/* <Switch
              valueLabel="Ponte Aérea"
              label=""
              name="aerialMesh"
              checked={state.aerialMesh}
              onChange={handleChange}
            />
            <Switch
              valueLabel="Preferencia de Aeroportos"
              label=""
              onChange={handleChange}
              checked={state.airportPreference}
              name="airportPreference"
            />
            <Switch
              valueLabel="Seguro"
              label=""
              onChange={handleChange}
              name="insurance"
              checked={state.insurance}
            /> */}
          </Box>
          {state.aerialMesh && (
            <>
              <Box display={"flex"} gap={2} mt={1}>
                {state.airportConnections.map((el: any, index: number) => {
                  return (
                    <Box
                      display={"flex"}
                      gap={1}
                      alignItems={"flex-end"}
                      width={"100%"}
                      key={index}
                    >
                      <AirportSearch
                        onSelectAirport={addConnection}
                        apiData={el}
                        name={`${index}`}
                        label="Aeroporto de Conexão"
                      />
                      <Box mb={1}>
                        <FaTrashAlt onClick={() => removeConnection(index)} />
                      </Box>
                    </Box>
                  );
                })}
              </Box>
              <Box margin={1}>
                <span
                  style={{
                    color: "#015EFF",
                    cursor: "pointer",
                    padding: "5px",
                  }}
                  onClick={() => addAirportConnection()}
                >
                  {" "}
                  Adicionar Parada{" "}
                </span>
              </Box>
            </>
          )}

          <FormGroup>
            <FormLabel>Categoria de Vôo</FormLabel>
            <LabeledAutoComplete
              multiple
              options={flightClassOptions}
              inputValue={flightCategory}
              value={selected}
              disablePortal
              getOptionLabel={(option) => option.label || ""}
              size="small"
              label=""
              renderInput={(params) => {
                return (
                  <TextField
                    {...params}
                    onChange={(
                      e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
                    ) => {
                      setFlightCategory(e.target.value);
                    }}
                  />
                );
              }}
              onChange={handleChangeCategories}
            />
            {/* {flightClassOptions.map((option: any) => {
              return (
                <FormControlLabel
                  label={option.label}
                  control={
                    <Checkbox
                      checked={state.flightClass.includes(option.value)}
                      onChange={() => handleSelect(option.value)}
                    />
                  }
                />
              );
            })} */}
          </FormGroup>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              flex: 1,
              justifyContent: "flex-end",
              marginTop: 2,
            }}
          >
            <Button
              variant="outlined"
              color="error"
              onClick={() => handleDeleteDialog(index)}
            >
              <span>Remover</span>
            </Button>
          </Box>

          {/* <StyledH2Before>
            <span onClick={() => handleDeleteDialog(index)}>
              {" "}
              <FaTrashAlt size={14} color={"#FF6262"} /> Apagar {title}
            </span>
          </StyledH2Before> */}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export { AerialServiceItem };
